import React from 'react';
import { useSelector } from 'react-redux';

import { MessageTemplateShare as MessageTemplate } from '~/types/models';
import { RootState, LandingPageType } from '~/types/redux/share';
import VideoLibraryCta from '~/Share/components/NextGen/VideoLibraryCta';
import { ReduxState } from '~/types/redux/share';
import Linkify from '~/App/Components/Linkify';
import { Assignee } from '~/types/api/nextgen';

interface AuthorMessageProps {
  assignee: Assignee;
  messageTemplate: MessageTemplate;
  model: RootState['model'];
  landingPageType: LandingPageType;
}

export default function AuthorMessage(props: AuthorMessageProps) {
  const { assignee, messageTemplate, model, landingPageType } = props;
  const { ctaClicked } = useSelector((state: ReduxState) => ({
    ctaClicked: state.tracking.ctaClicked,
  }));

  return (
    <div className='author-message'>
      <div className='comment-author'>{assignee.first_name || 'Sender'}</div>

      <div className='comment-item'>
        <Linkify className='comment-text' text={model.message} />
        <div onClick={ctaClicked}>
          {messageTemplate.cta.is_displayed &&
            landingPageType === LandingPageType.Recording && (
              <VideoLibraryCta
                messageTemplate={messageTemplate}
                recordingId={model.id}
              />
            )}
          {messageTemplate.cta.is_displayed &&
            landingPageType === LandingPageType.Greet && (
              <div className='comment-cta option-cta'>
                <a
                  href={messageTemplate.cta.url}
                  id='cta-button'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: messageTemplate.primary_color,
                    border: `0.15rem solid ${messageTemplate.color}`,
                    backgroundColor: messageTemplate.cta.color,
                  }}
                >
                  {messageTemplate.cta.text}{' '}
                  {messageTemplate.cta.text.length < 25 && (
                    <i className='fas fa-external-link'></i>
                  )}
                </a>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
